import { SelectedMenuContent } from 'rangeConfig/@types';
import { CoreApi, ProductType } from '@inter-ikea-storageone/range';
import deleteProduct from 'rangeConfig/shared/behaviors/deleteProduct';
import replaceProduct from 'rangeConfig/shared/behaviors/replaceProduct';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import removeTopPanelFromSelectedEntity from 'rangeConfig/besta/behaviors/removeTopPanel';
import { hideTopPanelsMenu } from 'rangeConfig/shared/rules/hideMenuRules';
import { colorFilter } from 'rangeConfig/shared/filters/configFilters';
import addFrontStyleToFrame from 'rangeConfig/shared/behaviors/addFrontStyleToFrame';
import addFrontLayout from 'rangeConfig/besta/behaviors/addFrontLayout';
import { supportLegSelection } from 'rangeConfig/besta/selection';
import { hideSupportLegsMenu } from 'rangeConfig/besta/rules/hideMenuRules';
import autoFillLegsWithSupport from 'rangeConfig/besta/behaviors/autoFillLegsWithSupport';
import {
  matchDepth,
  matchFrameFrontType,
  matchHeight,
  matchWidth
} from 'rangeConfig/shared/filters/selectedMenuProductFilters';
import {
  matchTopPanelDepth,
  matchTopPanelWidth,
  supportLegs
} from 'rangeConfig/besta/filters/selectedMenuProductFilters';
import { getQPPImage } from 'products/utils';
import DimensionsLabel from 'rangeConfig/shared/widgets/DimensionsLabel';
import platform from 'rangeConfig/shared/utils/platform';
import addTopPanelToFrame from 'rangeConfig/besta/behaviors/addTopPanelToFrame';
import {
  selectedFrameHasAnyTopPanel,
  selectedFrameHasTopPanel
} from 'rangeConfig/besta/utils/topPanels';

const selectedMenuContent = (): SelectedMenuContent[] => {
  return [
    {
      id: 'frames-selected-menu-front-layout',
      title: 'storageone.frontLayoutTabTitle',
      cardsTitle: 'name',
      cardsSubtitle: '',
      productThumbToolTip: 'name',
      behaviors: {
        productDropped: [showDoors, addFrontLayout],
        productClicked: [showDoors, addFrontLayout]
      },
      productTypes: [ProductType.BESTA_FRONT_LAYOUT],
      productFilters: [matchWidth, matchDepth, matchHeight],
      hideInfoButton: true,
      hidePrice: true,
      alternativeSelectedProductList: true,
      sortOrder: [{ path: 'coreProductId' }]
    },
    {
      id: 'frames-selected-menu-front-style',
      title: 'storageone.frontStyleTabTitle',
      cardsTitle: 'name',
      cardsSubtitle: 'designText',
      cluster: ['name', 'design'],
      productCardMainImage: getQPPImage,
      productCardHoverImage: getQPPImage,
      filters: [colorFilter],
      behaviors: {
        productDropped: [showDoors, addFrontStyleToFrame],
        productClicked: [showDoors, addFrontStyleToFrame]
      },
      productTypes: [
        ProductType.BESTA_DOOR_64_ASM,
        ProductType.BESTA_DOOR_38_ASM,
        ProductType.BESTA_DOOR_192_ASM,
        ProductType.BESTA_DRAWER_38_ASM,
        ProductType.BESTA_DRAWER_26_ASM
      ],
      productFilters: [matchFrameFrontType]
    },
    {
      id: 'frames-selected-menu-top-panels',
      title: 'storageone.productListTopPanelsTitle',
      cardsTitle: 'name',
      cardsSubtitle: 'communicatedSizeText',
      productThumbToolTip: 'designText',
      productCardMainImage: getQPPImage,
      behaviors: {
        productDropped: [addTopPanelToFrame],
        productClicked: [addTopPanelToFrame]
      },
      productTypes: [ProductType.BESTA_TOP_PANEL, ProductType.BESTA_TOP_PANEL_TV_BENCH],
      hidden: hideTopPanelsMenu,
      productFilters: [matchTopPanelWidth, matchTopPanelDepth],
      selected: selectedFrameHasTopPanel,
      noneOption: {
        behaviors: { removeProducts: [removeTopPanelFromSelectedEntity] },
        selected: (coreApi: CoreApi) => !selectedFrameHasAnyTopPanel(coreApi),
        title: 'storageone.productListNoTopPanelsOptionTitle'
      }
    },
    {
      id: 'frames-selected-menu-frames',
      title: 'storageone.productListFramesTitle',
      productThumbToolTip: 'designText',
      behaviors: {
        productClicked: [replaceProduct],
        productDropped: [replaceProduct]
      },
      productFilters: [matchWidth, matchDepth, matchHeight]
    },

    {
      id: 'frames-selected-menu-support-legs',
      title: 'storageone.productListSupportLegsTitle',
      behaviors: {
        productClicked: [autoFillLegsWithSupport],
        productDropped: [autoFillLegsWithSupport]
      },
      productTypes: [ProductType.BESTA_LEG, ProductType.BESTA_SUPPORTING_LEG],
      hidden: hideSupportLegsMenu,
      overrideSelection: supportLegSelection,
      productFilters: [supportLegs]
    }
  ];
};

const widgets = () => {
  return {
    desktop: [
      {
        id: 'display-size',
        title: 'storageone.sizeFilterLabel',
        component: DimensionsLabel
      },
      ...selectedMenuContent()
    ],
    mobile: selectedMenuContent()
  };
};

const selectedMenu = {
  menuTitle: 'storageone.selectedProductListCustomiseFrame',
  behaviors: {
    productDeleted: [deleteProduct]
  },
  content: widgets()[platform]
};

export default selectedMenu;
